<template>
<div>
    <div class="titleInfoBox">
        <div class="text">{{jobInfo.positionName + '---' + jobInfo.corporate}}</div>
        <el-button type="primary" plain @click="showAddJobNotice">添加公告</el-button>
    </div>
    <div class="itemList">
        <div class="itemDiv" v-for="item in dataList" :key="item.id">
            <div class="leftDiv">
                <P>{{item.notice}}</P>
            </div>
            <div class="rightDiv">
                <div>
                      <el-popover
    placement="right"
    title="提示"
    width="200"
    trigger="click"
     v-model="item.visible"
  >
      <p>是否删除该条公告</p>
  <div style="text-align: right; margin: 0">
    <el-button size="mini" type="text" @click="item.visible = false">取消</el-button>
    <el-button type="primary" size="mini" @click="item.visible = false;deleteNotice(item)">确定</el-button>
  </div>
    <el-button slot="reference">删除该公告</el-button>
  </el-popover>
                    
                </div>
            </div>
        </div>
    </div>
    <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal">
        </el-pagination>
    </div>
    <el-dialog title="职位公告" :visible.sync="dialogVisible" width="30%">
        <div class="demo-input-suffix">
            <p>职位公告：</p>
            <el-input placeholder="请输入要展示的职位公告(4000字以内)" type="textarea" v-model="jobNotice" maxlength="400" >
            </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false;saveNotice()">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'jobNotice',
    props: {},
    data() {
        return {
            jobNotice: '',
            positionName: '',
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            id: '',
            dialogVisible: false,
            setid: '',
            setItem: {},
            setPdfUrl: '',
            setnum: '',
            selectType: '待审核',
            selectTypeArray: {
                "待审核": 1,
                "已审核": 2,
                "审核失败": 3
            },
            monthlyPay: 0,
            moneyReward: 0,
            entryDate: '',
            commissionMethod: false,
            homeAmount: 0,
            warrantyAmount: 0,
            jobInfo: {

            },
            tdrInfo: {},
            tdrInfoStatus: false,
            reasShBox: false,
            shsbInfoStatus: false,
            setShsbItem: {
                sbyyInfo: ''
            },
        }
    },
    watch: {

    },
    created: function () {
        this.id = this.$route.query.id
        this.getJobInfo()
    },
    methods: {
        showAddJobNotice: function () {
            this.dialogVisible = true
        },  

        deleteNotice: function (item) {
                        let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/jobNotice/delJobNotice',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    id: item.id,
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.pageNumber = 1
                    that.jobNotice = ''
                    that.getJobNoticeList()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },

        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getJobNoticeList()
        },
        saveNotice: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/jobNotice/saveJobNotice',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    jobId: this.id,
                    notice: this.jobNotice
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.pageNumber = 1
                    that.dialogVisible = false
                    that.jobNotice = ''
                    that.getJobNoticeList()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        getJobNoticeList: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/jobNotice/getJobNoticeList',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    jobId: this.id,
                    pageSize: this.pageSize,
                    pageNum: this.pageNumber
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    for (let i in demo) {
                        demo[i].visible = false
                    }
                    that.dataList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        getJobInfo: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/job/getJob',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    jobId: this.id
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.jobInfo = response.data.content
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },

    },
    mounted: function () {
        this.getJobNoticeList();
        this.getJobInfo();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.itemList {
    margin-top: 20px;
}

.itemList .itemDiv {
    background-color: #ffffff;
    width: 80%;
    margin: 0 auto 15px auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px;
    border-radius: 8px;
    min-height: 150px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.itemList .itemDiv .leftDiv {
    width: 70%;
}

.itemList .itemDiv .leftDiv p {
    font-size: 18px;
    color: #757373;
    white-space: pre-wrap;
    word-wrap: break-word;
}

.itemList .itemDiv .leftDiv div {
    padding: 30px 0;
}

.itemList .itemDiv .rightDiv {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.itemList .itemDiv .rightDiv p {
    font-size: 32px;
    color: #1AAD19;
    text-align: center;
}

.itemList .itemDiv .rightDiv .active {
    color: red;
}

.itemList .itemDiv .rightDiv div {
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.block {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
}

.demo-input-suffix>p {
    padding: 10px 0;
}

.reasShBox {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
}

.reasShBox>div {
    width: 50vw;
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;
}

.reasShBox>div>iframe {
    width: 100%;
    height: 100%;
}

.reasShBox>div:nth-child(1) {
    background-color: #ffffff;
    padding: 30px;
    box-sizing: border-box;
}

.reasShBox>div .title {
    padding: 10px 0;
    width: max-content;
    background-color: #cecece;
}

.reasShBox>div .cont {
    padding: 10px;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
}

.reasShBox .buttonBox {
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.titleInfoBox{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 30px 200px;
    box-sizing: border-box;
}

.titleInfoBox .text{
    padding-right: 20px;
}
</style>
